/**
 * @description 新主页接口
 */
import http from '@/service/http'
import {ROOT_SIMULATOR, ROOT_RESOURCE} from './urlConfig'

export interface PrimaryPageButton {
    buttonCode: string
    name: string
    description?: string | null
    sceneCategoryId?: number | string | null
    iconUrl?: string | null
    videoUrl?: string | null
    redirectUrl?: string | null
}

//获取首页一级页面公共按钮
export const getPrimaryPageButtons = ()=>{
    return http.get<PrimaryPageButton[]>(ROOT_SIMULATOR+'/api/sceneManage/getPrimaryPageButtons')
}

//获取首页场景类型标签列表
export const getSceneTypes= (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getSceneTypeTabList',params)
}

//获取二级页面场景管理类型标签列表
export const getSceneCategory = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getSceneCategoryTabList',params)
}

//获取二级页面的数据
export const getSecondaryPageData = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getSecondaryPageData',params)
}

//获取二级页面教学场景
export const getTeachingSceneInfoTab = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getTeachingSceneInfoTab',params)
}

//获取二级页面练习场景
export const getExerciseSceneInfoTab = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getExerciseSceneInfoTab',params)
}


//根据SceneTypeId获取关联无人机型号
export const getSceneUavList = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getSceneUavSpListBySceneTypeId',params)
}

//获取三级页面场景列表
export const getSceneInfoTabList = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getSceneInfoTabStationsList',params)
}

//获取二级页面考试场景
export const getExamSceneInfoTab = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getExamSceneInfoTabStations',params)
}

//获取用户训练数据设置
export const getUserTrainingSetting = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/getUserTrainingSetting',params)
}

//保存用户训练数据设置
export const saveUserTrainingSetting = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/saveUserTrainingSetting',params)
}

//获取学习计划最左侧列表和总飞行时长
export const getTrainingPlanMainVo = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/trainingPlan/getTrainingPlanMainVo',params)
}

//获取学习计划最左侧列表和总飞行时长
export const getTrainingPlanSecVo = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/trainingPlan/getTrainingPlanSecVo',params)
}

//根据场景ID获取场景信息
export const getSceneInfoBySceneId = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getSceneInfoBySceneId',params)
}




